import React from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

const AreYouReady = () => {
  const whatsappMessage = 'Hola, me interesa la propuesta de cobertura 360 de TNO Network para Actitud Plateada 2026 (Pickleball y Pádel 55+).';

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography variant="h4" fontWeight={700} gutterBottom align="center">
          ¿Listo para llevar Actitud Plateada al siguiente nivel?
        </Typography>
        <Typography align="center" color="textSecondary" variant="h6" sx={{ maxWidth: 560, mx: 'auto' }}>
          Autoridad, modernidad y un ecosistema de medios con propósito. Conectemos tu evento con la audiencia que merece.
        </Typography>
      </Box>
      <Box maxWidth={480} margin="0 auto">
        <Box display="flex" flexDirection={{ xs: 'column', sm: 'row' }} gap={2} justifyContent="center">
          <Button
            variant="contained"
            color="primary"
            size="large"
            fullWidth
            sx={{ height: 54 }}
            onClick={() => window.open(`https://wa.me/584123964576?text=${encodeURIComponent(whatsappMessage)}`, '_blank')}
          >
            Solicitar propuesta Actitud Plateada
          </Button>
          <Button
            href="https://www.tnonetwork.com"
            variant="outlined"
            color="primary"
            size="large"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ height: 54 }}
            fullWidth
          >
            Conocer TNO Network
          </Button>
        </Box>
      </Box>
      <Box marginTop={4} textAlign="center">
        <Typography variant="body2" color="textSecondary">
          © TNO Network 2026 | The Content Evolution.
        </Typography>
      </Box>
    </Box>
  );
};

export default AreYouReady;
